import { UserProfile } from '../../auth/api';
import { APPROVAL_STATUS, APPROVAL_STEP_STATUS } from '../constants';
import { ApprovalDataViewModel, ApprovalStep } from '../types';

/**
 * Derive if
 *   - the currently logged-in user is one of the approvers
 *   - they can view the approval actions
 *   - they can execute approval actions
 */
export function getReviewApprovalDerivedState(
    approvalData: ApprovalDataViewModel | undefined | null,
    userProfile: UserProfile
): {
    userStep: ApprovalStep | null;
    isUserAllowedToViewApprovalActions: boolean;
    isUserAllowedToExecuteApprovalActions: boolean;
} {
    const userStep =
        approvalData?.steps?.find((step) => step.contact.personReference?.id === userProfile?.personReference?.id) ??
        null;

    const isUserAllowedToViewApprovalActions =
        Boolean(userStep) &&
        userStep.status === APPROVAL_STEP_STATUS.pending &&
        approvalData?.status === APPROVAL_STATUS.sent;

    const isUserAllowedToExecuteApprovalActions = isUserAllowedToViewApprovalActions && (userStep?.canAct ?? false);

    return { userStep, isUserAllowedToViewApprovalActions, isUserAllowedToExecuteApprovalActions };
}
